<template>
  <component :is="chartComponent" :data="data" />
</template>

<script>
import TimeSeriesChart from '@/xvisor/components/custom/charts/TimeSeriesChart.vue';
import TopnPieChart from '@/xvisor/components/custom/charts/TopnPieChart.vue';

const panelTypeEnum = {
  nfTs: 'nf-ts',
  nfTopn: 'nf-topn',
  xtTs: 'xt-ts',
  xtTopn: 'xt-topn',
};

const panelTypeToComponent = new Map([
  [
    panelTypeEnum.nfTs,
    TimeSeriesChart,
  ],
  [
    panelTypeEnum.nfTopn,
    TopnPieChart,
  ],
  [
    panelTypeEnum.xtTs,
    TimeSeriesChart,
  ],
  [
    panelTypeEnum.xtTopn,
    TopnPieChart,
  ],
]);

export default {
  props: {
    panelType: {
      type: String,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    chartComponent() {
      const cmpt = panelTypeToComponent.get(this.panelType);
      return cmpt;
    },
  },
};
</script>
